import { render, staticRenderFns } from "./ProjectMag.vue?vue&type=template&id=881b42ce&scoped=true&"
import script from "./ProjectMag.vue?vue&type=script&lang=js&"
export * from "./ProjectMag.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMag.vue?vue&type=style&index=0&id=881b42ce&scoped=true&lang=css&"
import style1 from "./ProjectMag.vue?vue&type=style&index=1&id=881b42ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881b42ce",
  null
  
)

export default component.exports